// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchExamples-cls1_jFh","cls2":"ResearchExamples-cls2_bFn ResearchExamples-cls1_jFh","lowered":"ResearchExamples-lowered_S_h"};